<template>
  <div class="container">
    <safe-header title="能源数智化管理平台" :nameStatus="true"></safe-header>
    <div class="wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 40px;">
        <el-breadcrumb-item :to="{ path: '/' }">返回首页</el-breadcrumb-item>
        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        <div v-for="(item, index) in routes.children" :key="index" v-show="url === `${routes.path}/${item.path}`">
          <el-breadcrumb-item>{{ item.meta.title }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
      <div class="main">
        <div class="main-left">
          <router-link v-for="(item, index) in routes.children" :key="index" :class="url === `${routes.path}/${item.path}` ? 'active' : ''" class="a" :to="`${routes.path}/${item.path}`">{{ item.meta.title }}</router-link>
        </div>
        <div class="main-right">
          <keep-alive>
            <router-view/>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import safeHeader from '@/views/base/safeHeader/safeHeader'
export default {
  name: 'Layout',
  components: {
    safeHeader
  },
  computed: {
    routes () {
      return this.$router.options.routes[0]
    }
  },
  watch: {
    '$route.path': 'changeUrl'
  },
  data () {
    return {
      url: this.$route.path
    }
  },
  methods: {
    changeUrl (curVal, oldVal) {
      this.url = curVal
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  height: 100vh;
  width: 100%;
  background: url('../../assets/img/bg.jpg') top left/100% 100% no-repeat;
}
.wrapper{
  position: relative;
  margin: 50px auto 0;
  width: 860px;
  .main{
    display: flex;
    .main-left{
      width: 25%;
      min-height: 300px;
      display: flex;
      flex-direction: column;
      border-right: 2px solid #0936a5;
      .a{
        text-indent: 65px;
        line-height: 50px;
        color: #fff;
        border-bottom: 1px solid #0936a5;
        &.active{
          color: #d9fdff;
          text-shadow: 2px 2px 8px #b8f5f5;
        }
        &:hover{
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }
    .main-right{
      width: 75%;
      padding: 20px;
    }
  }
}
</style>
<style>
.el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
  color: #508aff !important;
}
.el-breadcrumb__inner{
  color: #fff !important;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue